import { createSlice } from '@reduxjs/toolkit'
import { views } from 'data/constants'


let initialState = {
    datos:[],
    teacherInfo: {},
    infoSchedule: {},
    activeNotification: false,
    classStarted: {
        startClass: '',
        active: false,
        endClass: '',
    },
    infoTimer: {},
    view: views.CONTROLASITENCIA,
}
const persistLocalStorage = ( key, value) => {
    localStorage.setItem(key, JSON.stringify(value))
}
export const Teacherkey = 'user'
export const teacherSlice = createSlice({
    name: 'teacher',
    initialState: localStorage.getItem(Teacherkey) ? JSON.parse(localStorage.getItem(Teacherkey)) :  initialState,
    reducers:{
        addTeacher : (state, action) => {
            state.datos = {
                ...action.payload
            }
            persistLocalStorage(Teacherkey, state);
        },
        updateTeacherInfo: ( state, action) => {
            const result = {...state, ...action.payload };
            persistLocalStorage(Teacherkey, result);
            return result;
        },
        clearTeacher: ( state, action ) => {
            localStorage.removeItem(Teacherkey);
            return initialState
        },
        updateWaitingTimeAction: (state, action) => {
            //const newTimer = {...state.infoTimer, ...action.payload};
            state.infoTimer =  {...state.infoTimer, ...action.payload}
        }
    }
})
export const { addTeacher, addInfoTeacher, addLastCheck, clearTeacher, updateTeacherInfo, updateWaitingTimeAction} = teacherSlice.actions; 

export default teacherSlice.reducer 
